import { render } from "./UiBlock.vue?vue&type=template&id=56756ad0"
import script from "./UiBlock.vue?vue&type=script&lang=js"
export * from "./UiBlock.vue?vue&type=script&lang=js"

import "./UiBlock.vue?vue&type=style&index=0&id=56756ad0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__